export enum ProductVariant {
  Land = "land,voice",
  LandIoT = "land,iot",
  LandIoTDocker = "land,iot,docker",
  Maritime = "maritime,voice",
  MaritimeIoT = "maritime,iot",
  Aviation = "aviation,voice",
  AviationIoT = "aviation,iot",
  ComCenter = 'land,voice,citadel',
  ComCenterAltm = 'land,voice,citadel,altm',
  Citadel = 'maritime,voice,citadel',
  CitadelAltm = 'maritime,voice,citadel,altm'
}

export interface ProductVariantOption {
  label: string;
  value: ProductVariant;
}

export const PRODUCT_VARIANT_OPTIONS: ProductVariantOption[] = [
  { label: 'Land', value: ProductVariant.Land },
  { label: 'Land IoT', value: ProductVariant.LandIoT },
  { label: 'Land IoT EDGE.ai', value: ProductVariant.LandIoTDocker },
  { label: 'Maritime', value: ProductVariant.Maritime },
  { label: 'Maritime IoT', value: ProductVariant.MaritimeIoT },
  { label: 'Aviation', value: ProductVariant.Aviation },
  { label: 'Aviation IoT', value: ProductVariant.AviationIoT },
  { label: 'Land Citadel', value: ProductVariant.ComCenter },
  { label: 'Land Citadel Altm', value: ProductVariant.ComCenterAltm },
  { label: 'Maritime Citadel', value: ProductVariant.Citadel },
  { label: 'Maritime Citadel Altm', value: ProductVariant.CitadelAltm },
];

export function getProductVariantLabel(productVariant?: ProductVariant | string): string {
  const option = PRODUCT_VARIANT_OPTIONS.find(option => option.value === productVariant);
  return option?.label || productVariant || '';
}

export function isIotProductVariant(productVariant?: ProductVariant | string): boolean {
  return !!productVariant && productVariant.split(',').indexOf('iot') !== -1;
}

export interface DeviceTypeModel {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  productCode: string;
  productVersion: string;
  productModel: string;
  productType: string;
  platformType: string;
  manufacturer: string;
  productVariantDisplay: string;
  productVariant: ProductVariant;
}
